<template>
  <view class="my-tabbar" v-if="showFooter">
    <view
      v-for="item in tabbarComputed"
      :key="item.key"
      class="a-flex a-col a-ai-c a-flex-1 a-relative"
      @click="changeTabBar(item)"
    >
      <view class="a-w-50 a-h-50 a-relative">
        <text
          class="a-w-50 a-h-50 a-fs-50 a-c-#59"
          :class="[(selected === item.key && isRun) || item.alwaysHighlight ? 'run' : '', item.icon, item.customStyle]"
        ></text>
      </view>

      <view
        class="a-fs-18 a-h-18 a-lh-18rpx a-c-#8c a-mt-8"
        :class="{ 'always-highlight': item.alwaysHighlight, active: selected === item.key }"
        >{{ item.text }}</view
      >
      <view class="dot" v-if="item.hasNewData"></view>
    </view>
    <MaskedPopup :visible="isShowPopup" @closeMask="isShowPopup = false">
      <CommonlyUsed v-if="isShowPopup" pageFrom="popup" />
    </MaskedPopup>
  </view>
</template>

<script>
import { jumpOnlineService } from '@/utils/common/onlineService.js';
import { refConfig } from '@/common/config/refConfig.js';
import { commonApi } from '@/common/config.js';
import { GetReadFlag } from '@/api/common/common.js';
import MaskedPopup from '@/componentsV3/biz/MaskedPopup/index.vue';
import CommonlyUsed from '@/pages/index3.0/offenUsed/index.vue';

export default {
  props: {
    selected: {
      type: String,
      default: 'home',
    },
  },
  components: {
    MaskedPopup,
    CommonlyUsed,
  },
  data() {
    return {
      tabbars: [
        {
          icon: 'tripwise_outline icon-room_outline',
          text: '首页',
          url: '/pages/index/index',
          key: 'home',
        },
        {
          icon: 'tripwise_outline icon-examine_outline',
          text: '审批',
          url: '/pages/order3.0/approvalList',
          key: 'approval',
          hasNewData: false,
        },
        {
          icon: 'tripwise_outline icon-contact_outline',
          text: '在线客服',
          alwaysHighlight: false,
          key: 'onlineService',
        },
        {
          icon: 'tripwise_fill icon-add_fill',
          text: '常用',
          key: 'offen',
          customStyle: 'offen-icon',
        },
        {
          icon: 'tripwise_outline icon-trip_outline',
          text: '行程',
          url: '/pages/order3.0/triplist',
          key: 'order',
          hasNewData: false,
        },
        {
          icon: 'tripwise_outline icon-my_outline',
          text: '我的',
          url: '/pages/my/index/index',
          key: 'my',
        },
      ],
      activeName: '首页',
      showFooter: true,
      isOpenBonusPoints: false,
      IsUserNewExpense: false,
      isRun: true,
      isShowPopup: false,
    };
  },
  computed: {
    // tabbar过滤逻辑
    tabbarComputed() {
      let tabbars = this.tabbars;
      // 是否有审批,有审批不展示客服
      if (!this.isApproval) {
        tabbars = tabbars.filter((item) => item.key !== 'approval');
      } else {
        tabbars = tabbars.filter((item) => item.key !== 'onlineService');
      }
      const findApproveItem = tabbars.find((item) => item.key === 'approval');
      if (findApproveItem) {
        findApproveItem.url = this.IsUserNewExpense
          ? '/pages/expenseControl/approve/index/index'
          : '/pages/order3.0/approvalList';
      }
      if (this.isOpenBonusPoints) {
        // 如果开通积分，改变部分页面的url
        const findHomepage = tabbars.find((a) => a.key == 'home');
        findHomepage && (findHomepage.url = '/pages/index3.0/index');
        const findMypage = tabbars.find((a) => a.key == 'my');
        findMypage && (findMypage.url = '/pages/my2.0/index/integral');
      }
      return tabbars;
    },
    isApproval() {
      let settings = this.$app.GetSettings();
      return settings.IsApprover;
    },
    errorOrderCount() {
      return this.$store.state.common.hasErrorOrderCount || 0;
    },
  },
  watch: {
    errorOrderCount: {
      handler(val) {
        let orderItem = this.tabbars.find((a) => a.key == 'order');
        if (orderItem) {
          orderItem.hasNewData = this.errorOrderCount > 0 ? true : false;
        }
      },
      immediate: true,
    },
  },
  mounted() {
    let settings = this.$app.GetSettings();
    if (settings.RefId == refConfig.dingdingyifang) {
      this.showFooter = false;
    } else {
      this.showFooter = true;
      this.init();
      this.getErrorOrderCount();
    }
  },
  methods: {
    init() {
      let settings = this.$app.GetSettings();
      if (settings.isLogin) {
        this.isOpenBonusPoints = settings.isOpenBonusPoints || false;
        this.IsUserNewExpense = settings.IsUserNewExpense || false;
      } else {
        if (!this.$app.isSpecialPlat()) {
          uni.navigateTo({
            url: '/pages/loginAndRegister/login/login?isindex=1',
          });
        }
        return;
      }
      this.getCount();
    },
    getCount() {
      if (this.isApproval) {
        this.$app.Post(
          commonApi.GetToDoApproveListSummary,
          {},
          (data) => {
            if (this.$app.GetResultState(data)) {
              getApp().globalData.waitHandleCount = data.Data.DataCount.toString();
              const findApproveItem = this.tabbarComputed.find((item) => item.key === 'approval');
              if (findApproveItem) {
                findApproveItem.hasNewData = data.Data.DataCount > 0;
              }
            }
          },
          null,
          true,
        );
      }
    },
    getErrorOrderCount() {
      this.$app.request(GetReadFlag, {}, (res) => {
        if (this.$app.GetResultState(res)) {
          this.$store.commit('common/setHasErrorOrderCount', res.Data || 0);
        }
      });
    },
    changeTabBar(item) {
      if (this.selected !== item.key) {
        if (item.key === 'onlineService') {
          jumpOnlineService();
          return;
        }
        // 如果点击了常用
        if (item.key === 'offen') {
          this.isShowPopup = true;
          this.$Sensors.clickTrack('tabbar_commonly_used_click', '底部导航_常用');
        }
        uni.reLaunch({
          url: item.url,
        });
      } else {
        this.isRun = false;
        setTimeout(() => {
          this.isRun = true;
        });
      }
    },
  },
};
</script>

<style scoped lang="less" scoped>
.my-tabbar {
  width: 100%;
  height: 120rpx;
  background-color: #fff;
  padding: 24rpx 20rpx 20rpx 20rpx;
  position: fixed;
  z-index: 101;
  bottom: calc(var(--window-bottom));
  box-shadow: 0px 8rpx 50rpx 0px rgba(0, 0, 0, 0.06);
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.active {
  color: #057bff;
  font-weight: 600;
}
.run {
  color: #057bff;
  animation: scale_img 0.2s ease;
}
.always-highlight {
  color: #057bff;
}
@keyframes scale_img {
  0% {
    transform: scale(0.8);
  }
  100% {
    transform: scale(1);
  }
}
.dot {
  width: 16rpx;
  height: 16rpx;
  border-radius: 100%;
  background-color: #f85a5b;
  position: absolute;
  top: 0;
  left: 60%;
}
.offen-icon {
  color: #057bff;
  width: 90rpx;
  height: 90rpx;
  font-size: 90rpx;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}
</style>
